import { useEffect } from 'react';
import { HubConnectionBuilder, HubConnectionState, HubConnection } from "@microsoft/signalr"
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { useAuth0 } from "@auth0/auth0-react";
import { AlertNotificationsButton, NotificationsButton } from "../notifications/notificationsButton"
import { URLJoin } from '../../utils/urlUtils';
import { rootApiUrl } from '../../AppSettings';
import { selectNewNotificationReceived, setNewNotification, setNewNotificationReceived } from './notificationsSlice';
import { sanitizeEmail } from '../../utils/emailUtils';

export function NotificationPanel(){
    const newNotificationReceived = useAppSelector(selectNewNotificationReceived)
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()
    const dispatch = useAppDispatch ()
    const buildHyperLink = () => {
        return  URLJoin(rootApiUrl,'notificationHub');
     }
    useEffect(() => {

        const setupSignalRConnection = async () => {
            if (isAuthenticated) {  
                try {
                    const accessToken = await getAccessTokenSilently({ authorizationParams : {
                    }})
                    if (user?.email) {
                        const connection = new HubConnectionBuilder()
                        .withUrl(buildHyperLink(), {
                            accessTokenFactory: () => {
                                return accessToken
                            }
                        })
                        .build();
        
                        connection.on(sanitizeEmail(user.email), (message) => {
                            dispatch(setNewNotificationReceived(true))
                            let notification: Notification = message as Notification
                            dispatch(setNewNotification(message))
                            
                        });
                        try{
                            await connection.start();
                        }
                        catch (err){
                        }
                    }
                } catch (error)  {
                }
              }
        }
    
        setupSignalRConnection()
    }, [getAccessTokenSilently, isAuthenticated])
    return (
        
        <span>
            {isAuthenticated ?
           newNotificationReceived ? <AlertNotificationsButton/>  : <NotificationsButton/> 
            :null }
          </span>                      
    )
}
